import * as React from 'react';
import { ComplexValue, Numberbox, DateTime, ValidationProps } from 'ui';
import { SelectSingleRadioButton } from 'ui/select-single-short-list/select-single-radio-button/select-single-radio-button';
import { RecurringRangeOptions, ScheduleFieldKeys } from 'app/area/company-report/constants';
import { ScheduleDefinition } from 'app/area/company-report/types-store';
import { createFormatters, createUTCDate, dateToUTC, parseAsDateUTC } from 'app/infrastructure/data/date';
import { toUTCDateWithLocalOffset, newDateOrUndefined } from './schedule-helpers';
import styles from './report-screen.scss';

interface ScheduleRecurrenceRangeProps {
  scheduleDefinition: ScheduleDefinition;
  onChangeRangeOfRecurrenceOption: (val: ComplexValue<number>) => void;
  onChangeEndAfterOccurences: (val: number) => void;
  onChangeRangeEndByDate: (val: Date) => void;
  locale: string;
  getValidationErrors: (key: string) => ValidationProps;
  translations: { no_end_date: string; end_after: string; end_by: string; occurences: string };
}

export const ScheduleRecurrenceRange = ({
  scheduleDefinition, onChangeRangeOfRecurrenceOption, onChangeEndAfterOccurences, onChangeRangeEndByDate,
  locale, getValidationErrors, translations: { no_end_date, end_after, end_by, occurences }
}: ScheduleRecurrenceRangeProps) => {

  const selectedRangeOptionValue = scheduleDefinition?.recurrenceRange?.value;
  const selectedEndAfterOccurences = scheduleDefinition?.recurRangeEndAfter;
  const selectedRangeEndByDate = toUTCDateWithLocalOffset(newDateOrUndefined(scheduleDefinition?.recurRangeEndBy));
  const isSelectedRangeOption = (value: number): boolean => selectedRangeOptionValue === value;

  return <>
    <div className={` ${styles.scheduleRow} ${selectedRangeOptionValue === undefined ? 'has-danger' : ''}`}>
      <div>
        <SelectSingleRadioButton
          componentId={`${ScheduleFieldKeys.recurrenceRange}-no-end-date`}
          onChange={onChangeRangeOfRecurrenceOption}
          isSelected={isSelectedRangeOption(RecurringRangeOptions.NoEndDate)}
          option={{ value: RecurringRangeOptions.NoEndDate, description: no_end_date }}
          validation={getValidationErrors(ScheduleFieldKeys.recurrenceRange)}
        />
      </div>
    </div>
    <div className={` ${styles.scheduleRow}`}>
      <div className={styles.textWrapper}>
        <SelectSingleRadioButton
          componentId={`${ScheduleFieldKeys.recurrenceRange}-end-after`}
          onChange={onChangeRangeOfRecurrenceOption}
          isSelected={isSelectedRangeOption(RecurringRangeOptions.EndAfter)}
          option={{ value: RecurringRangeOptions.EndAfter, description: end_after }}
          validation={getValidationErrors(ScheduleFieldKeys.recurrenceRange)}
        />
      </div>
      <div>
        <Numberbox
          componentId={ScheduleFieldKeys.recurRangeEndAfter}
          value={selectedEndAfterOccurences}
          onChange={onChangeEndAfterOccurences}
          className={styles.scheduleNumberbox}
          readOnly={!isSelectedRangeOption(RecurringRangeOptions.EndAfter)}
          locale={locale}
          validation={getValidationErrors(ScheduleFieldKeys.recurRangeEndAfter)}
          maxValue={999999999}
        />
      </div>
      <div className={styles.textWrapper}>
        <span className={styles.texts}>{occurences}</span>
      </div>
    </div>
    <div className={`${styles.scheduleRow}`}>
      <div className={styles.textWrapper}>
        <SelectSingleRadioButton
          componentId={`${ScheduleFieldKeys.recurrenceRange}-end-by`}
          onChange={onChangeRangeOfRecurrenceOption}
          isSelected={isSelectedRangeOption(RecurringRangeOptions.EndBy)}
          option={{ value: RecurringRangeOptions.EndBy, description: end_by }}
          validation={getValidationErrors(ScheduleFieldKeys.recurrenceRange)}
        />
      </div>
      <div className="col-sm-6 col-md-4">
        <DateTime
          locale={locale}
          componentId={ScheduleFieldKeys.recurRangeEndBy}
          className={`dateTime ${styles.scheduleDateTime}`}
          value={selectedRangeEndByDate}
          onChange={onChangeRangeEndByDate}
          parseDate={parseAsDateUTC}
          {...createFormatters(locale)}
          createDate={createUTCDate}
          cloneDate={dateToUTC}
          readOnly={!isSelectedRangeOption(RecurringRangeOptions.EndBy)}
          validation={getValidationErrors(ScheduleFieldKeys.recurRangeEndBy)}
          useTime={false}
          captionWrapper={'form'}
        />
      </div>
    </div>
  </>;
};
